module.exports = __webpack_public_path__ + "static/media/School_Workspace_Class_Import_Template.12c56e22.xlsx";